import React from "react";
import styles from "./Label.module.scss";

const Label = ({ icon = "", label, value, webcam = false }) => {
  return (
    <div className={`${styles.label} ${webcam ? styles.webcam : ""}`}>
      <div className={styles.label__wrapper}>
        {icon && <img src={icon} alt="label" />}
        <div className={styles.label__label}>{label}</div>
      </div>
      <div className={styles.label__value}>{value}</div>
    </div>
  );
};

export default Label;
